import { styled } from '@mui/material/styles'
import Typography, {TypographyProps} from '@mui/material/Typography'


export const AuthTypography = styled(Typography)<TypographyProps>(({ theme }) => ({
    fontSize: theme.typography.h4.fontSize,
    fontWeight: 'bold',
    color: 'darkslategray',
}))